import { parseFilters } from '../../../libs/filter.lib'
import {
  QueryStringFilter,
  QueryStringSort,
} from '../../../models/query-string.model'
import {
  SupplierSearchField,
  SupplierSearchParams,
  SupplierSortField,
} from '../models/supplier-search.model'

export function parseSupplierFilters(
  params: SupplierSearchParams,
  filters: SupplierSearchParams,
): SupplierSearchParams {
  return parseFilters(params, filters, supplierFilterParams)
}

export function supplierSortParams(
  params: SupplierSearchParams,
  sort: QueryStringSort<SupplierSortField>,
): SupplierSearchParams {
  const searchParams: SupplierSearchParams = {}

  switch (sort.field) {
    case 'code':
      searchParams.sort = 'code'
      searchParams.order = sort.order
      break
    case 'alias':
      searchParams.sort = 'alias'
      searchParams.order = sort.order
      break
    case 'businessName':
      searchParams.sort = 'businessName'
      searchParams.order = sort.order
      break
  }

  return {
    ...params,
    ...searchParams,
  }
}

export function supplierFilterParams(
  params: SupplierSearchParams,
  filter: QueryStringFilter<SupplierSearchField>,
): SupplierSearchParams {
  const searchParams: SupplierSearchParams = {}

  switch (filter.field) {
    case '_id':
      if (filter.operator === '=') {
        searchParams._id = filter.value
      }
      break
    case 'code':
      if (filter.operator === '=') {
        searchParams.code = filter.value
      }
      break
    case 'alias':
      if (filter.operator === '=') {
        searchParams.alias = filter.value
      }
      break
    case 'businessName':
      if (filter.operator === '=') {
        searchParams.businessName = filter.value
      } else if (filter.operator === 'contains') {
        searchParams['businessName:ct'] = filter.value
      }
      break
    case 'address1':
      if (filter.operator === '=') {
        searchParams.address1 = filter.value
      }
      break
    case 'email':
      if (filter.operator === '=') {
        searchParams.email = filter.value
      }
      break
    case 'city':
      if (filter.operator === '=') {
        searchParams.city = filter.value
      }
      break
    case 'province':
      if (filter.operator === '=') {
        searchParams.province = filter.value
      }
      break
    case 'countryCode':
      if (filter.operator === '=') {
        searchParams.countryCode = filter.value
      }
      break
  }

  return {
    ...params,
    ...searchParams,
  }
}
